import React, { useState, useEffect, useContext } from 'react';
import {IProps} from './types';
import Button from '@components/Button';
import actions from '@state/actions';
import { useDispatch, useSelector } from 'react-redux';
import selectors from '@state/selectors';
import DesignName from '../DesignName';
import Folders from '../Folders';
import { AuthContext } from '@utils/DOIgnition/AuthContext';
import * as S from './styles';
import C from '@assets/themes/colors';
import PreviewGrid from '../PreviewGrid';
import { getOEMName } from '@utils/editor';
import { StudioContext } from '@utils/DOIgnition/StudioContext';
import { useLocation } from 'react-router';
import ClickOutside from '@components/ClickOutside';
const uuid = require('react-uuid');

const FullPreview:React.FC<IProps> = (props) => {
  
  const dispatch = useDispatch();
  const authContext = useContext(AuthContext);
  const dsConfig = useSelector(selectors.dsConfig.getDSConfig);
  const [open, setOpen] = useState(props.open);
  const [showTags, setShowTags] = useState(false);
  const oemName = getOEMName(props.item.tags.oem,dsConfig)
  const studioContext = useContext(StudioContext);
  const maxformats=5;
  const [coordinates, setCoordinates] = useState({x: 0, y: 0});
  const [position, setPosition] = useState({x: 0, y: 0});
  const [hiddenTags, setHiddenTags] = useState<string[]>([]);
  let hiddenNum = 0;
  let hiddenArray :string[] = [];

  const customTagRef = React.useRef() as React.MutableRefObject<HTMLDivElement>
  
  let location = useLocation();

  const handleOpen = () => {

    props.setOpen(false);

    if (location.pathname==="/studio" && studioContext && props.item.entityType==="TEMPLATE") {
      studioContext.addDesignFromTemplate(props.item);
    }
    else if (location.pathname==="/templates")
      window.open(`/editor/template/${props.item.id}`);    
    else if (props.item.entityType==="DESIGN") window.open(`/editor/design/${props.item.id}`);    
  }
  


  useEffect(()=>{
      if (customTagRef && customTagRef.current && customTagRef.current.childNodes)
      {   
        let parentPos = customTagRef.current.getBoundingClientRect();     
        let tags = new Array()
        Array.from(customTagRef.current.childNodes).map((element:any, index:number)=>{
          var data = element.getBoundingClientRect();
          if (data.top> parentPos.bottom){
            tags.push(element.innerText);                                 
          }
        })
        setHiddenTags(tags);
      }
        
  },[])

  const handleCoordinates = (e: any) => {
    setCoordinates({x: e.clientX, y: e.clientY});
  }

  const handlePosition = (e: any) => {
    let data =  e.target.getBoundingClientRect()
    setPosition({x: data.left, y: data.top});
  }

  const renderSizes = () => {
    var sizes = "";
    var sizesArray: any = [];
    if (props.item.tags?.formats && props.item.tags.formats.length > 0) {
      props.item.tags.formats.map((format: any, index: number) => {
        if (index < maxformats) sizesArray.push(`${format.width}x${format.height}`);
      })
      sizes = sizesArray.join(", ");      

        return (
          <S.TagItem>
            {sizes}
            {
              props.item.tags.formats.length > maxformats &&
              <>
              <S.SubtitleBold  onMouseEnter={handleCoordinates}>
                +{props.item.tags.formats.length - maxformats}                          
            {               
              <S.FormatsAbsoluteContainer
                id={`formats-hover-${props.item.id}`}
                leftValue={`${coordinates.x - 100}px`}
                bottomValue={`${window.innerHeight - coordinates.y - 60}px`}
              >
                <S.FormatsContainer>
                  {
                    props.item.tags.formats.map((format: any, index: number) => {
                      return (
                        <S.FormatLabel key={index} >
                          {`${format.name} - ${format.width}px x ${format.height}px`}
                        </S.FormatLabel>
                      )
                    })
                  }
                </S.FormatsContainer>
              </S.FormatsAbsoluteContainer>
            }
            </S.SubtitleBold>
            </>
          }
            </S.TagItem>
                     
        )
    }
    return <></>
      
  }
    
  const getSizeFactor=()=>{    
    if (props.item.previews)
    {
      if (props.item.previews.length==1)
        return 1
    }
    return 1.6
  }
  

  return (
    <S.Root style={{
      display: open ? 'flex' : 'none',
    }} >
      <S.BoxContainer>
        <S.TitleContainer>
          <S.LeftSide>
            <S.Title>
              {props.item.name}
            </S.Title>
            <S.SubtitleContainer>
              <S.Subtitle>
              {`Created by ${props.item.createdBy?.name ? props.item.createdBy.name : "Deafault User"}, 
                ${new Intl.DateTimeFormat('en-US',{day:'2-digit', month:'2-digit', year:'2-digit'}).format(new Date(props.item.createdDate))}
              `}
              </S.Subtitle>
              <S.Hour>
              {new Intl.DateTimeFormat('en-US',{hour:'2-digit', minute:'2-digit'}).format(new Date(props.item.createdDate))}
              </S.Hour>
            </S.SubtitleContainer>
          </S.LeftSide>
        </S.TitleContainer>
        <S.Content>
            <S.PreviewContent width={props.item.previews?props.item.previews.length==1? '100%': '600px':'100%'}>
                  <PreviewGrid
                    images={props.item.previews}
                    designType={props.item.tags?.designType}
                    width={ props.item.previews?props.item.previews.length==1? 900: 600:900}
                    height={props.item.previews?props.item.previews.length==1? 400: 380:900}
                    size={getSizeFactor()}
                    names={true}                    
                  />
              </S.PreviewContent>        
        </S.Content>
        <S.TagsContainer>
          <S.TagItem>{oemName}</S.TagItem>
          <S.TagItem> | </S.TagItem>
          <S.TagItem>{props.item.tags.platform}</S.TagItem>
          {
            props.item.tags.offerType &&
            <>
            <S.TagItem> | </S.TagItem>
            <S.TagItem>{props.item.tags.offerType}</S.TagItem>
            </>
          }
            {
            props.item.tags.holiday &&
            <>
            <S.TagItem> | </S.TagItem>
            <S.TagItem>{props.item.tags.holiday}</S.TagItem>
            </>
          }
          <S.TagItem> | </S.TagItem>
          {
            renderSizes()
              
          }
         
        </S.TagsContainer>
        {
          props.item.tags.customTags && props.item.tags.customTags.length>0 &&
          <>
          <S.CustomTagsTitle>Custom Tags:</S.CustomTagsTitle>
          <S.CustomContainer>
          <S.CustomTagsContainer ref={customTagRef}>
          {
                props.item.tags.customTags.map((custom: any, index: number) => {
                  return (
                    <S.CustomTagItem onClick={()=>{props.onTagSelected(custom);props.setOpen(false)}}>
                      {`${custom}`}
                    </S.CustomTagItem>
                  )
                })                
            }          
            
          </S.CustomTagsContainer>
          <S.CustomTagsCounter>
            {              
              hiddenTags && hiddenTags.length>0 &&  <S.CustomTagItem onMouseEnter={handlePosition} onClick={()=>setShowTags(true)}>+{hiddenTags.length}</S.CustomTagItem>
            }  
          </S.CustomTagsCounter>
          </S.CustomContainer>
          </>
        }
        {
          showTags &&
          <ClickOutside onClickOutside={()=> setShowTags(false)} event={"mousedown"}>
          <S.CustomTagsAbsoluteContainer
            leftValue={`${position.x }px`}
            bottomValue={`${window.innerHeight - position.y  }px`}
          >
             {
                hiddenTags.map((custom: any, index: number) => {
                  return (
                    <S.CustomTagItemExtra onClick={()=>{props.onTagSelected(custom);props.setOpen(false)}}>
                      {`${custom}`}
                    </S.CustomTagItemExtra>
                  )
                })                
            }  
          </S.CustomTagsAbsoluteContainer>
          </ClickOutside>
        }

        <S.ActionsContainer>
          <S.Action>
            <Button
              label={`BACK ${location.pathname==="/studio"? "TO DASHBOARD":location.pathname==="/templates"?"TO TEMPLATES":""}`}
              style={{
                width: '150px',
                marginRight: 12, 
                backgroundColor: "transparent", 
                border: `1px solid ${C.DARK_ORANGE}`, 
                hoverBackgroundColor: `${C.DARK_ORANGE}22`,
              }}
              labelStyle={{color: C.DARK_ORANGE}}
              onClick={() => props.setOpen(false)}
            />
          </S.Action>
          <S.Action>
            <Button
              label={ location.pathname==="/studio"? props.item.entityType==="TEMPLATE"?"USE THIS TEMPLATE":"OPEN THIS DESIGN":  props.item.entityType==="TEMPLATE"? "OPEN THIS TEMPLATE":"OPEN THIS DESIGN" }
              style={{
                width: '155px',
                flexGrow: 0,
                backgroundColor: C.DARK_ORANGE, 
                hoverBackgroundColor: `${C.DARK_ORANGE}AA`,
              }} 
              onClick={handleOpen}              
            />
          </S.Action>
        </S.ActionsContainer>
      </S.BoxContainer>
    </S.Root>
  );
}

export default FullPreview;